import React from "react";
import { Col, Row } from "react-bootstrap";
import { CgCPlusPlus } from "react-icons/cg";
import {
  DiJavascript1,
  DiReact,
  DiNodejs,
  DiMongodb,
  DiPython,
  DiGit,
  DiJava,
} from "react-icons/di";
import {
  SiRedis,
  SiFirebase,
  SiNextdotjs,
  SiSolidity,
  SiPostgresql,
} from "react-icons/si";
import { TbBrandGolang } from "react-icons/tb";

function Techstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons">
      <b className="fs-5 text-center">
      Website Designing
                </b>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
      <b className="fs-5 text-center">
      Bugs Resolving
                </b>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
      <b className="fs-5 text-center">
      Graphic Designing
                </b>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
      <b className="fs-5 text-center">
      App Development
                </b>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
      <b className="fs-5 text-center">
      Web Development
                </b>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
      <b className="fs-5 text-center">
      College Projects
                </b>
      </Col>
    </Row>
  );
}

export default Techstack;


